import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/learnerReading.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter as Router } from 'react-router-dom';


// Suppress ResizeObserver and MetaMask/SES errors (harmless warnings)
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;
console.error = function filterWarnings(msg, ...args) {
  if (typeof msg === 'string' && (msg.includes('ResizeObserver') || msg.includes('loop') || msg.includes('SES_UNCAUGHT'))) {
    return;
  }
  originalConsoleError(msg, ...args);
};
console.warn = function filterWarnings(msg, ...args) {
  if (typeof msg === 'string' && (msg.includes('SES_') || msg.includes('lockdown'))) {
    return;
  }
  originalConsoleWarn(msg, ...args);
};

window.addEventListener('error', e => {
  if (e.message && (e.message.includes('ResizeObserver') || e.message.includes('loop completed with undelivered'))) {
    const resizeObserverErr = e;
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
// Dev-only: suppress noisy MetaMask inpage.js connection errors
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (e) => {
    try {
      const msg = String(e.reason || '');
      if (msg.includes('MetaMask') || msg.includes('inpage.js')) {
        e.preventDefault();
      }
    } catch {}
  });
}
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
